







import { Component, Vue, Prop } from 'vue-property-decorator';
import { IIssueType } from '@/lib/interfaces';
import { getAllIssueTypes } from '@/services/api.service';

@Component
export default class IssueTypeRow extends Vue {
  @Prop() private type!: IIssueType;
  // Если нет type, то сами делаем запрос
  @Prop() private typeId!: string;

  private responseType: IIssueType | null = null;

  private async mounted() {
    if (this.typeId) {
      const types = await getAllIssueTypes();
      this.responseType = types.find((t) => t._id === this.typeId)!;
    }
  }

  private get finalType(): IIssueType {
    return this.type || this.responseType;
  }
}
